import * as React from "react";
export var MarketProfilePicture = function (_a) {
    var profileName = _a.profileName, children = _a.children;
    var className = "profile_image sprite-profiles-large profiles-large-" + profileName;
    return React.createElement("div", { className: className }, children);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/MarketProfilePicture.tsx
// module id = 2716
// module chunks = 3